import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";

export const fileTypeMap: { [key: string]: IconName } = {
  FOLDER: "folder",
  pdf: "file-pdf",
  doc: "file-word",
  docx: "file-word",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  xls: "file-excel",
  xlsx: "file-excel",
  jpeg: "file-image",
  jpg: "file-image",
  png: "file-image",
  gif: "file-image",
  bmp: "file-image",
  tif: "file-image",
  dwg: "map",
  ifc: "map",
  plt: "map",
  mpg: "map",
  mpeg: "map",
  mov: "map",
  qt: "map",
  wmv: "map",
};

export const FileMalware = () => (
  <FontAwesomeIcon color="#ffa500" fixedWidth={true} size="lg" icon={["far", "virus"]} />
);

export const FileZeroSize = () => (
  <FontAwesomeIcon color="#ffa500" fixedWidth={true} size="lg" icon={["far", "band-aid"]} />
);

const renderFileStateIcon = (state: API_FILEDATAENTITY_STATE) => {
  let icon: IconName;
  if (state === "SYMLINK") {
    icon = "link";
  } else if (state === "LOCKED") {
    icon = "lock";
  } else {
    return null;
  }
  return (
    <FontAwesomeIcon
      fixedWidth={true}
      icon={["fas", icon]}
      className="file-state-icon"
      transform="shrink-2 right-8 down-6"
    />
  );
};

const renderFileRelationIcon = (relation: API_FILEDATAENTITY_RELATIONS[], state: API_FILEDATAENTITY_STATE = null) => {
  const renderData: JSX.Element[] = [];
  if (relation?.includes("MASTER") || relation?.includes("TASK")) {
    renderData.push(
      <div key="master-task" className="file-badge-icon master flex flex-all-center">
        <FontAwesomeIcon fixedWidth={true} icon={["fal", "plus"]} color="#ff8318" size="xs" />
      </div>
    );
  }
  if (relation?.includes("SLAVE") || relation?.includes("WORKFLOW")) {
    renderData.push(<div key="slave-workflow" className="file-badge-icon slave" />);
  }
  if (relation?.includes("SYMLINK") && state !== "SYMLINK") {
    renderData.push(
      <div key="symlink" className="file-badge-icon symlink-source">
        <FontAwesomeIcon fixedWidth={true} icon={["fas", "bow-arrow"]} className="file-state-icon" />
      </div>
    );
  }

  return renderData;
};

const renderFileRWMIcon = (accessright: string, fileActions: API_FileDataEntity["fileActions"] = {}) => {
  if (accessright === "1W" && fileActions.downloadPdf) {
    return (
      <FontAwesomeIcon fixedWidth={true} icon={["fas", "tint"]} color="#ff8318" transform="shrink-5 right-10 top-10" />
    );
  }
  return null;
};

interface FileTypeIconProps {
  type: string;
  malware: boolean;
  size?: number;
  state?: API_FILEDATAENTITY_STATE;
  relation?: API_FILEDATAENTITY_RELATIONS[];
  onClick?: () => void;
  linkedMailId?: number;
  accessright?: API_FileDataEntity["properties"]["accessright"];
  fileActions?: API_FileDataEntity["fileActions"];
}

export const FileTypeIcon = ({
  type,
  state,
  malware,
  relation,
  size,
  onClick,
  linkedMailId,
  accessright,
  fileActions,
}: FileTypeIconProps) => {
  if (malware) {
    return FileMalware();
  }

  if (size <= 0) {
    return FileZeroSize();
  }

  return (
    <span
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
    >
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon fixedWidth={true} size="lg" icon={["far", fileTypeMap[type] || "file-alt"]} />
        {renderFileStateIcon(state)}
        {!!linkedMailId && (
          <FontAwesomeIcon
            fixedWidth={true}
            icon={["fas", "envelope"]}
            className="file-state-icon"
            transform="shrink-2 right-8 down-6"
          />
        )}
        {renderFileRWMIcon(accessright, fileActions)}
      </span>
      {renderFileRelationIcon(relation, state)}
    </span>
  );
};
